import { FORM__CHANGE_CREATE_PROJECT_INPUT } from '../actions';
const initialState = {
  address: '',
  projectTypesCodes: [],
  typeClient: '',
  projectname: ''
};
export default (function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case FORM__CHANGE_CREATE_PROJECT_INPUT:
      {
        return {
          ...state,
          [action.payload.name]: action.payload.value
        };
      }
    default:
      return state;
  }
});